import type { SVGProps } from 'react';

type Props = { width?: number; height?: number; color?: string; primary_color?: string } & SVGProps<SVGSVGElement>;

export const SVG = (props: Props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox='0 0 512 512'
    xmlns='http://www.w3.org/2000/svg'
    fillRule='evenodd'
    clipRule='evenodd'
    strokeLinejoin='round'
    strokeMiterlimit='2'
  >
    <path d='M189.08 303.228H94.587l.044-94.446h94.497l-.048 94.446z' fill='#7c7c7c' fillRule='nonzero' />
    <path d='M283.528 397.674h-94.493l.044-94.446h94.496l-.047 94.446z' fill='#7c7c7c' fillRule='nonzero' />
    <path d='M283.575 303.228H189.08l.046-94.446h94.496l-.047 94.446z' fill='#7c7c7c' fillRule='nonzero' />
    <path
      d='M378.07 303.228h-94.495l.044-94.446h94.498l-.047 94.446zM189.128 208.779H94.633l.044-94.448h94.498l-.047 94.448zM378.115 208.779h-94.494l.045-94.448h94.496l-.047 94.448zM94.587 303.227H.093l.044-96.017h94.496l-.046 96.017z'
      fill='#7c7c7c'
      fillRule='nonzero'
    />
    <path d='M94.633 208.779H.138l.046-94.448H94.68l-.047 94.448z' fill='#7c7c7c' fillRule='nonzero' />
    <path
      d='M94.68 115.902H.185L.23 19.885h94.498l-.047 96.017zM472.657 114.331h-94.495l.044-94.446h94.497l-.046 94.446zM94.54 399.244H.046l.044-97.588h94.497l-.047 97.588z'
      fill='#7c7c7c'
      fillRule='nonzero'
    />
    <path
      d='M94.495 492.123H0l.044-94.446H94.54l-.045 94.446zM472.563 303.228H378.07l.044-94.446h94.496l-.047 94.446zM472.61 208.779h-94.495l.044-94.448h94.498l-.047 94.448z'
      fill='#7c7c7c'
      fillRule='nonzero'
    />
    <path d='M472.517 397.674h-94.494l.044-94.446h94.497l-.047 94.446z' fill='#7c7c7c' fillRule='nonzero' />
    <path d='M472.47 492.121h-94.493l.044-96.017h94.496l-.047 96.017z' fill='#7c7c7c' fillRule='nonzero' />
    <path d='M228.375 303.22h-96.061l.046-94.446h96.067l-.052 94.446z' fill={props.color} fillRule='nonzero' />
    <path d='M322.827 397.666h-94.495l.044-96.018h94.498l-.047 96.018z' fill={props.color} fillRule='nonzero' />
    <path d='M324.444 303.22h-97.636l.046-94.446h97.638l-.048 94.446z' fill={props.color} fillRule='nonzero' />
    <path d='M418.938 303.22h-96.064l.045-94.446h96.066l-.047 94.446z' fill={props.color} fillRule='nonzero' />
    <path
      d='M228.423 208.77H132.36l.045-94.445h96.066l-.05 94.446zM418.985 208.77H322.92l.044-94.445h96.069l-.048 94.446z'
      fill={props.color}
      fillRule='nonzero'
    />
    <path d='M133.883 304.79H39.392l.044-96.017h94.496l-.049 96.017z' fill={props.color} fillRule='nonzero' />
    <path d='M133.929 208.77H39.437l.044-95.445h94.496l-.048 95.445z' fill={props.color} fillRule='nonzero' />
    <path
      d='M133.976 114.325H39.484l.044-94.448h94.497l-.05 94.448zM511.954 115.325h-94.493l.044-95.448h94.497l-.048 95.448z'
      fill={props.color}
      fillRule='nonzero'
    />
    <path d='M133.836 399.667H39.345l.044-96.447h94.496l-.049 96.447z' fill={props.color} fillRule='nonzero' />
    <path d='M133.79 492.117H39.3l.044-94.448h94.496l-.049 94.448z' fill={props.color} fillRule='nonzero' />
    <path d='M511.862 303.22h-94.495l.046-94.446h94.496l-.047 94.446z' fill={props.color} fillRule='nonzero' />
    <path d='M511.907 208.77h-94.493l.044-94.445h94.496l-.047 94.446z' fill={props.color} fillRule='nonzero' />
    <path d='M511.815 398.666h-94.493l.044-95.447h94.496l-.047 95.447z' fill={props.color} fillRule='nonzero' />
    <path d='M511.77 492.117h-94.496l.046-94.448h94.496l-.047 94.448z' fill={props.color} fillRule='nonzero' />
  </svg>
);

export default SVG;
